export default __webpack_public_path__ + "static/media/logo_store.d0a215d4.svg";